import ApplicationController from './application_controller'

// "Refresh from Dropbox" (User#sync reflex): shows it's working while the
// sync runs
export default class extends ApplicationController {
  beforeSync(element) {
    $(element).find('.status').html(' Refreshing');
    $(element).addClass('progress');
  }

  syncError(element, reflex, error) {
    console.error('Dropbox sync failed', error)
  }

  afterSync(element) {
    $(element).find('.status').html('');
    $(element).removeClass('progress');
  }
}
